import "core-js";
import "settings";

import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import Ajax from "base/Ajax";

import "jquery-serializejson";
import Page from "webPage/Page";
import handleNavigation from "util/handleNavigation";
import handleAccordionBlocks from "blocks/handleAccordionBlocks";
import handleSubpageNavigation from "util/handleSubpageNavigation";
import handleScrollingSections from "util/handleScrollingSections";
import handleTestimonialSliders from "util/handleTestimonialSliders";
import handleGalleries from "util/handleGalleries";
import handleCountUpElements from "util/handleCounter";
import { handleVideoPlayers } from "util/handleVideoPlayers";
import PageAnimations from "webPage/PageAnimations";
import { scrollToElement } from "util/scrollToElement";
import handleBookEventModal from "./util/handleBookEventModal";
import handleSalesForceFormsBlocks from "blocks/handleSalesForceFormsBlocks";
import handleChartsBlocks from "blocks/handleChartsBlocks";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    Page.init();
    PageAnimations.start();
    handleNavigation();
    handleAccordionBlocks();
    handleSubpageNavigation();
    handleScrollingSections();
    handleTestimonialSliders();
    handleGalleries();
    handleCountUpElements();
    handleVideoPlayers();
    handleBookEventModal();
    handleSalesForceFormsBlocks();
    handleChartsBlocks();

    $('body').on('click', '.js-scroll-to', function () {
        let $el = $($(this).attr('href'));

        scrollToElement($el);

        return false;
    }).on('click', 'a[href^="#"]', function () {
        let $el = $($(this).attr('href'));

        scrollToElement($el, 400, true);

        return false;
    });
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
window.Ajax = Ajax;
